<template>
  <div
    v-if="authData.isApplicationReportingEnabled && reqReportUrl"
    class="view-req-report"
    @click="$emit('view-req-report')"
  >
    <router-link
      class="view-req-report-inner-container"
      :to="{ path: reqReportUrl || '' }"
      target="_blank"
      rel="noopener noreferrer"
    >
      <v-icon
        size="12px"
        class="mr-1"
        color="mignightBlue"
        icon="$poll"
      />
      <span>View Req Progress</span>
    </router-link>
  </div>
</template>

<script setup>
import { useEditor } from '@/stores/editor/editor';
import { useAppAuthData } from '@/stores/app/authData';
import { storeToRefs } from 'pinia';

const { reqReportUrl } = storeToRefs(useEditor());
const { authData } = storeToRefs(useAppAuthData());

defineEmits(['view-req-report']);
</script>

<style scoped lang="less">
.view-req-report {
  min-width: 149px;
  margin-top: 12px;

  .view-req-report-inner-container {
    display: flex;
    align-items: center;
    border-radius: 8px;
    background: @bg-canvas;
    font-weight: 400;
    color: @text-darkest;
    cursor: pointer;
    padding: 4px 8px;
    font-size: 14px;
    white-space: nowrap;

    &:hover {
      color: @text-brand;
      background: @bg-canvas;

      i {
        color: @text-brand !important;
      }
    }
  }
}
</style>
